'use client';

import { type PropsWithChildren } from 'react';
import { DeviceHeaderContext } from './DeviceHeaderContext';
import type { Device } from '../../utils/types';

export const DeviceHeaderProvider = ({
  children,
  detectedDevice,
}: PropsWithChildren<{ detectedDevice: Device | null }>) => (
  <DeviceHeaderContext.Provider value={detectedDevice}>{children}</DeviceHeaderContext.Provider>
);
